import { ReactNode } from 'react'
import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../../../actions/Applications/Alert/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

/** What opens the alert. A missing handler makes its button close the alert. */
export type TAlertData = {
  cancelText?: string | null
  content?: ReactNode
  contentHeader?: string | null
  faIcon?: string | null
  faIconWarning?: boolean
  header?: string | null
  okText?: string | null
  onCancel?: () => void
  onOk?: () => void
  size?: string | null
}

export type AlertReducerType = TAlertData & {
  visible: boolean
}

const INITIAL_STATE: AlertReducerType = {
  cancelText: null,
  okText: null,
  onCancel: () => {},
  onOk: () => {},
  header: null,
  contentHeader: null,
  faIcon: null,
  faIconWarning: false,
  content: null,
  visible: false,
  size: 'sm'
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    // Replaces the whole alert, so an omitted handler stays unset.
    .addCase(actions.set, (_state, action) => {
      const { payload } = action

      return {
        cancelText: payload.cancelText,
        okText: payload.okText,
        onCancel: payload.onCancel,
        onOk: payload.onOk,
        header: payload.header,
        contentHeader: payload.contentHeader,
        faIcon: payload.faIcon,
        faIconWarning: payload.faIconWarning,
        content: payload.content,
        size: payload.size,
        visible: true
      }
    })
    .addCase(actions.reset, () => INITIAL_STATE)
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
